import React from 'react';
import { observer } from 'mobx-react-lite';
import {
  freeBetStore,
  userInfoStore,
  gameConfigStore,
  SlowConnectionWr,
  applicationStore,
  BetNotificationWr,
  notificationStore,
  ConnectionPopupsWr,
  UnderMaintenanceWr,
  useSoundWatcher,
} from '@pascal/pascal-core';

import { changeBetAmount, betAmountValidator, changeAutoCashOutOdd } from '../../../helpers';
import { GameMain } from '../gameMain';
import { doBetStore, gameStore } from '../../../store';
import { autoCashOutDataKeys, autoCashOutMaxOdd, minOdd } from '../../../enums/uiConfig';

const Game = observer(() => {
  const {
    limits: { maxWin },
  } = gameConfigStore;
  const { isDemo } = applicationStore;
  const { activeFreeBet } = freeBetStore;
  const { balance } = userInfoStore;
  const { currentFighterSection, setActiveCurrentSection } = gameStore;
  const { autoBetData, betData, autoCashOutData } = doBetStore;

  useSoundWatcher();

  const fighterData = betData.find((item) => item.fighterNumber === currentFighterSection);
  const currentAutoBetData = autoBetData.find((el) => el.fighterNumber === currentFighterSection);
  const currentAutoCashOutData = autoCashOutData.find(
    (el) => el.fighterNumber === currentFighterSection
  );

  const { amount, freeBetMinOdd } = fighterData;
  const { isOpened, autoCashOutOdd } = currentAutoCashOutData;

  const changeBetInputValue = (functionName) =>
    changeBetAmount(
      { isOpened, autoCashOutOdd: freeBetMinOdd || autoCashOutOdd },
      isDemo,
      functionName,
      doBetStore.setBetAmount,
      gameConfigStore.limits,
      balance,
      amount,
      notificationStore.setNotificationType
    );

  const handleSwitchAutoCashOut = () =>
    doBetStore.updateAutoCashOutData(
      autoCashOutDataKeys.isOpened,
      !isOpened,
      currentFighterSection
    );

  const handleChangeAutoCashOutInputValue = (functionName, value) => {
    changeAutoCashOutOdd(
      freeBetMinOdd || minOdd,
      amount,
      maxWin,
      functionName,
      autoCashOutOdd,
      value,
      notificationStore.setNotificationType,
      currentFighterSection
    );
  };

  const handleInputBlur = (betAmount) => betAmountValidator(betAmount, gameConfigStore.limits);

  return (
    <div className='fighter-game-wrapper'>
      <BetNotificationWr
        autoCashOutMaxOdd={autoCashOutMaxOdd}
        autoCashOutMinOdd={activeFreeBet?.id ? activeFreeBet?.minOdd : minOdd}
      />
      <UnderMaintenanceWr />
      <SlowConnectionWr />
      <ConnectionPopupsWr />
      <GameMain
        extraProps={{
          amount,
          balance,
          isOpened,
          fighterData,
          autoCashOutOdd,
          handleInputBlur,
          currentAutoBetData,
          currentFighterSection,
          setActiveCurrentSection,
        }}
        changeBetInputValue={changeBetInputValue}
        handleSwitchAutoCashOut={handleSwitchAutoCashOut}
        handleChangeAutoBet={doBetStore.updateAutoBetData}
        handleChangeAutoCashOutInputValue={handleChangeAutoCashOutInputValue}
      />
    </div>
  );
});

export default Game;
